import { Application } from "@hotwired/stimulus";
import { registerControllers } from "stimulus-vite-helpers";
import CategoryDropdownController from "~resources/js/controllers/category_dropdown_controller";
import OpenPanelController from "~resources/js/controllers/open_panel_controller";
import SharepointListController from "~resources/js/controllers/sharepoint_list_controller";

const application = Application.start();
const controllers = import.meta.glob("./**/*_controller.js", { eager: true });
registerControllers(application, controllers);

// register controllers shared with v9.1
application.register("category-dropdown", CategoryDropdownController);
application.register("open-panel", OpenPanelController);
application.register("sharepoint-list", SharepointListController);
